const appConfig = {
  previewGalleryAnnouncement: false,
  showApplicationMaintenance: false,
  showPurchaseRequestButtons: false,
  showPurchaseRequestButttonsTime: new Date('2025-05-26T16:00:00+00:00'),
  includePorto: true,
  showApplication: false,
  showApplicationViaLogin: true,
  showApplicationViaLoginForSome: [],
  showApplicationAnnouncement: false,
  showApplicationOver: true,
  showConfirmContract: true,
  restrictedMode: false,
  currentFairYear: '2024-1',
  links: {
    purchaseRequestGTC:
      'https://firebasestorage.googleapis.com/v0/b/imgs.kuboshow.de/o/AGBs_KUBOSHOW_KUNSTMESSE_23-1.pdf?alt=media',
  },
  functions: {
    onApplicationSent:
      'https://europe-west1-kuboshow-gdt.cloudfunctions.net/onApplicationSent',
    onPurchaseRequest:
      // 'http://localhost:5001/kuboshow-gdt/europe-west1/onPurchaseRequest',
      'https://europe-west1-kuboshow-gdt.cloudfunctions.net/onPurchaseRequest',
  },
  images: {
    globalOverlayStempelHeader: 'https://imgs.kuboshow.de/wp/KUBOSHOW_Schriftzug_2024_weiss.png',
    globalOverlayStempel:
      'https://dl3.pushbulletusercontent.com/W6VciXWHkz0SYmfTrdZN9PG8e8YgDu7l/KUBO%202025%20Logo_RZ.jpg',
    headerBgImage: 'https://imgs.kuboshow.de/wp/XXX-Akt-2000.jpg',
  },
}

export default appConfig
